const countClients = (text?: string) =>
  (text || "")
    .split(/\r?\n|;/)
    .map((line) => line.trim())
    .filter(Boolean).length;

export const buildClientLogoImages = (content?: any, listKey = "clients_list") => {
  const count = countClients(content?.[listKey]);
  return Array.from({ length: count }, (_, index) => content?.[`clients_logo_${index + 1}`]);
};
